module.exports = __webpack_public_path__ + "img/askmebet-support.29ef5c19.png";